module.exports = __webpack_public_path__ + "media/flags/009-australia-c27b24e5.svg";